// @core/api/endpoints/subscription/get_subscription_plan_change_preview.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetSubscriptionPlanChangePreviewResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Preview subscription plan change
 * Calculates and returns the financial impact of changing plans without executing the change. Shows credits, charges, and effective date.
 */
export async function GetSubscriptionPlanChangePreview(
  subscription_id: string,
  params?: {
    new_plan_id?: string | number | boolean;
    prorate?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetSubscriptionPlanChangePreviewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/plan-change/preview`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.get<GetSubscriptionPlanChangePreviewResponse>(requestPath, { ...requestOptions, params });
}
